export const PERMISSIONS = {
  ADMIN: {
    MANAGE_USERS:       "admin.users.manage",
    MANAGE_ROLES:       "admin.roles.manage",
    MANAGE_PERMISSIONS: "admin.permissions.manage",
    MANAGE_LEADERS:     "admin.leaders.manage",
  },
  RH: {
    CANDIDATES_MANAGEMENT: "rh.candidates.management",
    WHITELIST_MANAGE:      "rh.whitelist.manage",
    ONBOARDING_MAP:        "rh.onboardingmap.management",
    RESET_MISSIONS:        "rh.missions.reset",
    EDIT_MISSION_FIELDS:   "rh.missions.edit",
    APPROVE_MISSIONS:      "rh.missions.approve",
    MANAGE_ASO:            "rh.aso.manage",
    CANCEL_TICKET:         "rh.ticket.cancel",
    PROCESSES_VIEW:        "rh.processes.view",
    HISTORY_VIEW:          "rh.history.view",
    FIELD_OPTIONS_MANAGE:  "rh.field_options.manage",
    SALARY_VIEW:           "rh.salary.view",
    METRICS_VIEW:          "rh.metrics.view",
  },
  CYBER: {
    CANDIDATES_PDF: "cyber.candidates.pdf",
  },
} as const;
